import { useCallback, useContext, useEffect, useState } from 'react';

import { timeoutFetchSentryGuard } from 'Fetch';
import { getUserLogOut } from 'PrivateApis';

import { ConfigContext } from 'Context/config';
import { UserContext } from 'Context/user';

import { useAuthUI } from '../containers/app/experiments/useAuthUI/useAuthUI';

export const useRemoveUser = () => {
  const { isAuthUIJourney } = useAuthUI();
  const { configState: { authnApi } } = useContext(ConfigContext);
  const [isLogOutRedirect, setIsLogOutRedirect] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const { userState: user } = useContext(UserContext);

  const removeUser = useCallback(async (showToastNotification = false) => {
    await getUserLogOut()
      .catch((err) => {
        timeoutFetchSentryGuard(err, () => window?.Sentry?.captureException(new Error(err), {
          tags: {
            fetch: 'logout',
          },
        }));
      });
    setIsLogOutRedirect(true);
    setShowToast(showToastNotification);
  }, []);

  useEffect(() => {
    if (isLogOutRedirect) {
      const url = showToast ? '/?logout=notify' : '/';

      const revokeUrlParams = new URLSearchParams([
        ['redirectUri', `${window?.location?.origin}?logout=broadcast`],
        ['xSellerId', (user?.id)?.toString() ?? ''],
      ]);

      const redirectUrl = isAuthUIJourney ? `${authnApi}/oauth2/revoke?${revokeUrlParams.toString()}` : url;
      window.location.href = redirectUrl;
    }
  }, [authnApi, isAuthUIJourney, isLogOutRedirect, showToast, user?.id]);

  return {
    removeUser,
  };
};
